import { render, staticRenderFns } from "./ForeignCurrency.vue?vue&type=template&id=3fc96ef1&scoped=true&"
import script from "./ForeignCurrency.vue?vue&type=script&lang=js&"
export * from "./ForeignCurrency.vue?vue&type=script&lang=js&"
import style0 from "./ForeignCurrency.vue?vue&type=style&index=0&id=3fc96ef1&lang=scss&scoped=true&"
import style1 from "./ForeignCurrency.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc96ef1",
  null
  
)

export default component.exports